import { css } from '@emotion/core';

import { grid, SPACE_COZY, SPACE_COMPACT, textOverflowHidden } from '@/styles';

import { sharedCardStyles } from '../styles';

export const root = [
  sharedCardStyles,
  grid,
  css`
    box-sizing: border-box;
    align-items: center;
    grid-template-columns: repeat(3, minmax(0, auto));
    grid-template-rows: min-content 1fr;
    gap: 0;
    max-width: 480px;
    overflow: hidden;

    & > *:not(:first-of-type) {
      padding: ${SPACE_COZY}px;
    }
  `,
];

export const extending = css`
  max-width: none;
  // SLO is displayed here so we have 4 elements to spread across
  grid-template-columns: 1fr 1fr 1fr 1.5fr 0.5fr;
`;

export const header = css`
  grid-column: 1/-1;
`;

// NOTE: `[data-testid='mini-slo-graph-error']` is needed to truncate the
// `SectionMessage` `title`. It's not pretty as we're styling elements of an AK
// component via the `testId` prop. The selectors are as element agnostic as
// possible but, still, it relies on a specific DOM structure.
export const error = [
  css`
    grid-column: 1/-1;
    padding-bottom: ${SPACE_COMPACT}px !important;
    padding-top: ${SPACE_COMPACT}px !important;

    [data-testid='mini-slo-graph-error'] {
      > *:last-child {
        min-width: 0;

        > * {
          ${textOverflowHidden}
        }
      }
    }
  `,
];

export const warningContainer = css`
  display: flex;
  justify-content: center;
`;
